
window.APP_PROJECT_NAME = 'station-app-h5-global';
window.APP_LANGUAGE_MSG = {
  ar: () => import('@/assets/lang/ar/ar.json'),
  cht: () => import('@/assets/lang/cht/cht.json'),
  de: () => import('@/assets/lang/de/de.json'),
  en: () => import('@/assets/lang/en/en.json'),
  es: () => import('@/assets/lang/es/es.json'),
  fil: () => import('@/assets/lang/fil/fil.json'),
  fr: () => import('@/assets/lang/fr/fr.json'),
  id: () => import('@/assets/lang/id/id.json'),
  it: () => import('@/assets/lang/it/it.json'),
  ja: () => import('@/assets/lang/ja/ja.json'),
  ko: () => import('@/assets/lang/ko/ko.json'),
  ms: () => import('@/assets/lang/ms/ms.json'),
  nl: () => import('@/assets/lang/nl/nl.json'),
  pt: () => import('@/assets/lang/pt/pt.json'),
  th: () => import('@/assets/lang/th/th.json'),
  tr: () => import('@/assets/lang/tr/tr.json'),
  vi: () => import('@/assets/lang/vi/vi.json'),
  zh: () => import('@/assets/lang/zh/zh.json'),
};

export default {
  ar: () => import('@/assets/lang/ar/ar.json'),
  cht: () => import('@/assets/lang/cht/cht.json'),
  de: () => import('@/assets/lang/de/de.json'),
  en: () => import('@/assets/lang/en/en.json'),
  es: () => import('@/assets/lang/es/es.json'),
  fil: () => import('@/assets/lang/fil/fil.json'),
  fr: () => import('@/assets/lang/fr/fr.json'),
  id: () => import('@/assets/lang/id/id.json'),
  it: () => import('@/assets/lang/it/it.json'),
  ja: () => import('@/assets/lang/ja/ja.json'),
  ko: () => import('@/assets/lang/ko/ko.json'),
  ms: () => import('@/assets/lang/ms/ms.json'),
  nl: () => import('@/assets/lang/nl/nl.json'),
  pt: () => import('@/assets/lang/pt/pt.json'),
  th: () => import('@/assets/lang/th/th.json'),
  tr: () => import('@/assets/lang/tr/tr.json'),
  vi: () => import('@/assets/lang/vi/vi.json'),
  zh: () => import('@/assets/lang/zh/zh.json'),
};